import { render, staticRenderFns } from "./ShipmentNoteList.vue?vue&type=template&id=8a466552&scoped=true"
import script from "./ShipmentNoteList.vue?vue&type=script&lang=js"
export * from "./ShipmentNoteList.vue?vue&type=script&lang=js"
import style0 from "./ShipmentNoteList.vue?vue&type=style&index=0&id=8a466552&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a466552",
  null
  
)

export default component.exports